export default __webpack_public_path__ + "static/Rectangle2x-021740bd8454e42074b72b9a5dce91d4.png";